export const floatRight = {
  float: 'right',
}
